import styles from './styles.module.scss';
import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import { DownIcon, UpIcon } from '@/components/icons';
import { useConfigStore } from '@/stores/configStore';
import clsx from 'clsx';

const ICON_WIDTH = 11;
const ICON_HEIGHT = 8;

interface ShopFnbFacilityTriggerBuildingButtonProps extends BaseButtonProps {
    title: string;
    isActive: boolean;
    onClick: () => void;
}

const ShopFnbFacilityTriggerBuildingButton = ({ title, isActive, onClick, ...props }: ShopFnbFacilityTriggerBuildingButtonProps) => {
    const contrast = useConfigStore((s) => s.config?.ui?.contrast);

    return (
        <BaseButton
            className={clsx(styles['trigger-button'], {
                [styles['trigger-button--contrast']]: contrast,
            })}
            onClick={onClick}
            {...props}
        >
            <span>{title}</span>

            <span className={styles['trigger-button__icon']} aria-hidden>
                {isActive ? <UpIcon width={ICON_WIDTH} height={ICON_HEIGHT} /> : <DownIcon width={ICON_WIDTH} height={ICON_HEIGHT} />}
            </span>
        </BaseButton>
    );
};

export default ShopFnbFacilityTriggerBuildingButton;
